import actionTypes from 'SRC/modules/redux/actionTypes'

export const setGroups = (groups) => ({
  type: actionTypes.SET_GROUPS,
  payload: groups
})
